import {
    type GooglePlaceBusinessStatus,
    GooglePlaceBusinessStatusMap,
} from "@albertine/types";
import Tag from "../../Common/Tag";

type Props = {
    businessStatus: GooglePlaceBusinessStatus | null | undefined;
};

function BusinessStatus(props: Props) {
    const { businessStatus } = props;

    const BusinessStatusTag = Tag.Small.Bold;

    if (businessStatus === "CLOSED_PERMANENTLY") {
        return (
            <BusinessStatusTag.E90>
                {GooglePlaceBusinessStatusMap.CLOSED_PERMANENTLY}
            </BusinessStatusTag.E90>
        );
    }

    if (businessStatus === "CLOSED_TEMPORARILY") {
        return (
            <BusinessStatusTag.S80>
                {GooglePlaceBusinessStatusMap.CLOSED_TEMPORARILY}
            </BusinessStatusTag.S80>
        );
    }

    if (businessStatus === "OPERATIONAL") {
        return (
            <BusinessStatusTag.P90>
                {GooglePlaceBusinessStatusMap.OPERATIONAL}
            </BusinessStatusTag.P90>
        );
    }

    return (
        <BusinessStatusTag.N80>
            {GooglePlaceBusinessStatusMap.UNAVAILABLE}
        </BusinessStatusTag.N80>
    );
}

export default BusinessStatus;
